@if (store$ | async; as store) {
<div class="root" skyTranslationGuard="skypro-python-exercise">
  <div class="editor">
    <span>{{ 'skyproLibsBlocksPythonExercise.code' | transloco }}</span>
    <skypro-code-editor
      [code]="code$ | async"
      [closeBracket]="isAutoCloseBracket"
      (codeChange)="onCodeChange($event)"
    ></skypro-code-editor>
    <br />
    <div class="buttons">
      <ds-button
        class="button -run"
        size="s"
        type="primary-yellow"
        data-test="запустить"
        [disabled]="store.isExecuting"
        (click)="singleRun()"
      >
        @if (!store.isTestCaseCheckExecuting) {

        <img [src]="playIcon" class="play-icon" />
        <span>{{ 'skyproLibsBlocksPythonExercise.codeExecute' | transloco }}</span>

        } @else {

        <sky-ui-spinner size="m"></sky-ui-spinner>

        }
      </ds-button>
      <ds-button
        class="button -check"
        size="s"
        type="primary-mint"
        data-test="проверить"
        [disabled]="store.isExecuting"
        (click)="checkAnswer()"
      >
        @if (!store.isTestCasesSubmitExecuting) {
        <span>
          {{ 'skyproLibsBlocksPythonExercise.submitCode' | transloco }}
        </span>
        } @else {

        <sky-ui-spinner size="m"></sky-ui-spinner>

        }
      </ds-button>

      <ds-button
        class="button -reset -desktop"
        size="s"
        type="secondary-base"
        data-test="сбросить"
        dsTooltip="Начать сначала"
        dsTooltipPosition="bottom"
        (click)="showResetCodeModal()"
      >
        <img class="refresh-icon" [src]="refreshIcon" icon />
      </ds-button>
    </div>

    <ds-button
      class="button -reset -mobile"
      size="s"
      type="secondary-base"
      data-test="сбросить"
      (click)="showResetCodeModal()"
    >
      <img class="refresh-icon" [src]="refreshIcon" iconLeft />
      <span>{{ 'skyproLibsBlocksPythonExercise.retry' | transloco }}</span>
    </ds-button>
  </div>

  @if ((isCurrentRunCheck$ | async) && !store.isExecuting && store.testCasesRunResult[0]) {
  <skypro-python-exercise-test-case-description
    [result]="store.testCasesRunResult[0]"
  ></skypro-python-exercise-test-case-description>
  } @if (isCurrentRunSubmit$ | async) { @for (result of store.testCasesRunResult; track result; let
  index = $index; let last = $last) {

  <details class="test-case">
    <summary class="test-case-title">
      <div class="test-case-title-description">
        <img
          class="test-case-title-state"
          [src]="result.isSuccessCheck ? testCaseOkIcon : testCaseErrorIcon"
        />
        <span>
          {{ 'skyproLibsBlocksPythonExercise.test' | transloco : { value: index + 1 } }}
        </span>
      </div>
      <img class="test-case-title-arrow" [src]="arrowDownIcon" />
    </summary>
    <skypro-python-exercise-test-case-description
      [result]="result"
    ></skypro-python-exercise-test-case-description>
  </details>
  @if (!last) {
  <div class="splitter"></div>
  } } } @if (isResultMessageVisible$ | async) {
  <div class="result-message">
    <img class="result-message-icon" [src]="resultMessageIcon" />
    <span>{{ store.resultMessage | skyUiTypograf }}</span>
  </div>
  }
</div>
}

<!-- Скрываем все что пришло из CMS -->
<div [hidden]="true">
  <ng-content></ng-content>
</div>
